import { createFileRoute, Outlet } from '@tanstack/react-router';
import { ClientShell } from '../../../../components/shell/client-shell';
import { requireClient } from '../../../../lib/guards';

// The signed-in client area: needs a client session and a saved business profile, and wears the client app shell.
export const Route = createFileRoute('/subdomain/app/_client')({
  beforeLoad: ({ context }) => requireClient(context.queryClient),
  component: () => (
    <ClientShell>
      <Outlet />
    </ClientShell>
  ),
});
